import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import {useCartContext} from '../../context/CartContext';
import SyncAltTwoToneIcon from '@mui/icons-material/SyncAltTwoTone';
import type {ProductDetails} from '../../../product/models/ProductDetails';
import type {ProductPrice} from '../../../catalog/models/ProductPrice';
import type {BusinessCentralDiscounts} from '../../../product/models/BusinessCentralDiscounts';
import type {GiftDeal} from '../../../product/models/ProductDeals';
import {Spinner} from 'react-bootstrap';

interface Props {
  data: {
    details: ProductDetails,
    price: ProductPrice,
    quantity: number,
    bcDiscounts: BusinessCentralDiscounts,
    giftProductDeal?: GiftDeal,
    triggerAddToCart: boolean,
    disabled: boolean,
    blockOnClickAddToCArt: boolean,
    loading?: boolean,
  };
  actions?: {
    afterAddToCart?: () => void,
  };
}

export const AddToCart = ({ data, actions }: Props) => {
  const {
    details,
    price,
    quantity,
    bcDiscounts,
    giftProductDeal,
    triggerAddToCart,
    disabled,
    blockOnClickAddToCart,
    loading = false
  } = data;
  const { cart, addProduct } = useCartContext();
  const [isProductOnCart, setIsProductOnCart] = useState(false);

  const onAddToCart = async (
    isProductOnCart,
    details,
    price,
    quantity,
    bcDiscounts,
    giftProductDeal
  ) => {
    try {
      await addProduct(details.id, price, quantity, bcDiscounts, giftProductDeal);
      toast.success(`'${details.pro_nombre || details.pro_codigo}' agregado al carrito exitosamente.`);
    } catch (error) {
      toast.error(`'${details.pro_nombre || details.pro_codigo}' no pudo agregarse al carro. Por favor, reintente más tarde o contacte con nosotros.`);
    } finally {
      actions?.afterAddToCart && actions.afterAddToCart();
    }
  };

  useEffect(() => {
    if (cart && details) {
      setIsProductOnCart([...cart?.products, ...cart?.deprecatedProducts].some(it => it?.id === details.id));
    }
  }, [cart, details]);

  useEffect(() => {
    if (triggerAddToCart === true) {
      onAddToCart(isProductOnCart, details, price, quantity, bcDiscounts, giftProductDeal);
    }
  }, [triggerAddToCart]);

  return (
    <button type="button" className="btn btn-primary" disabled={disabled}
            onClick={async () => {
              if (blockOnClickAddToCart === undefined || blockOnClickAddToCart === false) {
                await onAddToCart(isProductOnCart, details, price, quantity, bcDiscounts, giftProductDeal);
              }
            }}>
      <div className="d-flex gap-1 align-items-center">
        {
          isProductOnCart === true ? (
            <>
              <SyncAltTwoToneIcon />&nbsp;<span>Actualizar</span>
            </>
          ) : (
            <>
              <ShoppingCartCheckoutIcon />&nbsp;<span>Agregar</span>
            </>
          )
        }
        { loading && <Spinner size="sm" /> }
      </div>
    </button>
  );
};